// src/components/QuestionCard.jsx
import React, {Fragment} from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from "../../store/UserContext";
import { FaFlag  } from 'react-icons/fa';
import {checkToken} from '../../Authentication/AxiosInstance';
const QuestionCard = ({ question }) => {
    const navigate = useNavigate();
    const {user} = useUser();
    const buttonClass = `m-1 p-2 h-auto w-fit 
                  bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                  border-2 rounded-lg 
                  text-base font-bold tracking-widest normal-case items-center`;
    const dateFormatFn = (v_date) => {
        console.log(v_date)
        if (!v_date) return null; // Prevent undefined errors
        const dateObj = new Date(v_date)
        let fullDate = null;
        let datePart = null;
        let timePart = null;
        if (v_date.length <= 10) {
            fullDate = dateObj.toLocaleDateString("en-GB", { month: "short", day: "2-digit", year: "2-digit" });
            datePart = fullDate.split(',')[0]
            timePart = null
        } else {
            fullDate = dateObj.toLocaleDateString("en-GB",{ month: "short", day: "2-digit", year: "2-digit"} ) + ", " + dateObj.toLocaleTimeString("en-GB", { hour:'numeric', minute:'numeric', hour12: true }).toUpperCase();
            datePart = fullDate.split(',')[0]
            timePart = fullDate.split(',')[1].trim()
        }
        console.log(fullDate, datePart,timePart)
        return [datePart,  timePart];
    };

    const QueryFlagButton = ({ question}) => {
        
        console.log('in inappropriate')
        
        const handleSubmit = async (e) => {
            e.stopPropagation(); // prevent box's onClick from firing
            const queryId = question?.id;
            await checkToken.post("/api/forumflag/", {
                c002_query: queryId,
                c002_reply: null
                });
        };
        console.log(user);
        return (
            <div className="flex">
                {console.log(user)}
                <button className={`group flex items-center space-x-2 ${buttonClass} cursor-pointer p-0 m-0`}
                        disabled={!user} 
                        onClick={handleSubmit} >
                    <FaFlag className="text-gray-500 group-hover:text-red-500 p-0 m-0 align-middle" />
                    <span className="text-primary-900 font-bold group-hover:text-white p-0 m-0 leading-none">
                        Report as InAppropriate
                    </span>
                </button>
            </div>
        );
    };
    const [datePart, timePart] = dateFormatFn(question.c002_query_created_date)
    console.log(question)
    return (
        <Fragment>
            <div className="flex flex-row items-stretch justify-center gap-x-4">
                <div className="flex items-center bg-gradient-to-r from-primary-100 to-primary-200 border border-primary-300 
                                                w-1/6 mb-1 white shadow-sm p-4 rounded-xl hover:shadow-lg transition cursor-pointer 
                                                gap-x-6">
                    <div className="flex flex-col items-center align-middle space-x-1 text-[12px]">
                        <div className="font-medium align-middle text-[12px]">{question.c002_query_authorname}</div>
                        <div className="text-xs">{datePart} &nbsp; {timePart}</div>
                    </div>
                </div>
                {question.c002_isqueryflagged ? (
                    <div className="w-5/6 mb-1 bg-white shadow-sm p-4 rounded-xl hover:shadow-lg transition 
                                    cursor-pointer border gap-x-6">
                        <div className="flex flex-row items-stretch italic bg-transparent">
                            <div className="flex flex-col flex-1 justify-between">
                                <h3 className="font-semibold text-gray-400 mb-1">This content is under moderation</h3>
                                <div className="text-gray-800 text-base mt-2 mb-1 mr-6">This content was manually reported as violating our code of conduct and hence, has been placed under moderation. </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="w-5/6 mb-1 bg-white shadow-sm p-4 rounded-xl hover:shadow-lg transition 
                                    cursor-pointer border gap-x-6"
                    onClick={() => navigate(`/forumqueryreplies/${question.id}`)}>
                        <div className="flex-1">
                            <h3 className="font-semibold text-gray-800 mb-1">{question.c002_query_subject}</h3>
                            <div className="text-gray-800 text-base mt-2 mb-1 mr-6 line-clamp-3">{question.c002_query_description}</div>
                        </div>
                        <div className="flex flex-row flex-1 items-center justify-end gap-x-2">
                            <div className="flex text-sm">{question.c002_like_count || 0} likes</div>
                            <div className="flex text-sm">{question.c002_reply_count || 0} replies</div>
                            {user && (
                                <div className="flex"><QueryFlagButton question = {question} reply={null}/></div>
                            )}
                        </div>
                    </div>
                )}        
            </div>
        </Fragment>
    );
};

export default QuestionCard;
